import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from "react-icons/fa";
import ContactForm from "@/components/ContactForm";

const Contact = () => {
  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-primary">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6">Свържете се с нас</h1>
            <p className="text-xl text-white max-w-2xl mx-auto">
              Имате нужда от довършителни работи? Свържете се с нас за безплатна консултация и оферта.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Контактна информация</h2>
            <div className="w-24 h-1 bg-[#FFC857] mx-auto mb-6"></div>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Свържете се с нас чрез формата за контакт или използвайте данните по-долу.
            </p>
          </div>
          
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="lg:w-1/2">
              <ContactForm />
            </div>
            
            <div className="lg:w-1/2">
              <div className="bg-primary text-white rounded-lg p-8 shadow-md mb-8">
                <h3 className="text-2xl font-heading font-bold mb-6">Информация за контакт</h3>
                
                <div className="flex items-start mb-6">
                  <div className="text-[#FFC857] text-xl mr-4">
                    <FaMapMarkerAlt />
                  </div>
                  <div>
                    <h4 className="font-bold mb-1">Адрес</h4>
                    <p>ул. "Бузлуджа" 40-42,<br />Петте кьошета, София 1463, България</p>
                  </div>
                </div>
                
                <div className="flex items-start mb-6">
                  <div className="text-[#FFC857] text-xl mr-4">
                    <FaPhoneAlt />
                  </div>
                  <div>
                    <h4 className="font-bold mb-1">Телефон</h4>
                    <p><a href="tel:+359877338382" className="hover:underline">+359 87 733 8382</a></p>
                  </div>
                </div>
                
                <div className="flex items-start mb-6">
                  <div className="text-[#FFC857] text-xl mr-4">
                    <FaEnvelope />
                  </div>
                  <div>
                    <h4 className="font-bold mb-1">Имейл</h4>
                    <p><a href="mailto:vanco.superliski@gmail.com" className="hover:underline">vanco.superliski@gmail.com</a></p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="text-[#FFC857] text-xl mr-4">
                    <FaClock />
                  </div>
                  <div>
                    <h4 className="font-bold mb-1">Работно време</h4>
                    <p>Понеделник - Петък: 9:00 - 18:00<br />Събота: 10:00 - 14:00<br />Неделя: Затворено</p>
                  </div>
                </div>
              </div>
              
              <div className="rounded-lg overflow-hidden shadow-md h-80">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2933.240152151915!2d23.3157831157249!3d42.681968879166776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa85607d7494df%3A0x8f8a44bae12ebe1f!2sBuzludzha%20St%2040-42%2C%201463%20Sofia%2C%20Bulgaria!5e0!3m2!1sen!2sus!4v1652356878123!5m2!1sen!2sus" 
                  width="100%" 
                  height="100%" 
                  style={{ border: 0 }} 
                  allowFullScreen={false} 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="V&M Group Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Често задавани въпроси</h2>
            <div className="w-24 h-1 bg-[#FFC857] mx-auto mb-6"></div>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Отговори на най-често задаваните въпроси от нашите клиенти.
            </p>
          </div>
          
          <div className="max-w-3xl mx-auto">
            <div className="mb-8">
              <h3 className="text-xl font-heading font-bold text-primary mb-2">
                Какъв е процесът на работа?
              </h3>
              <p className="text-gray-700">
                Процесът започва с безплатна консултация и оценка на обекта, след което ви изготвяме оферта. При одобрение от ваша страна се подписва договор и се определя график за работа. Следва изпълнение на проекта и финална проверка заедно с вас.
              </p>
            </div>
            
            <div className="mb-8">
              <h3 className="text-xl font-heading font-bold text-primary mb-2">
                Колко време отнема един стандартен ремонт на апартамент?
              </h3>
              <p className="text-gray-700">
                Времетраенето зависи от обема на работа и сложността на проекта. Обикновено, за довършителни работи на двустаен апартамент са необходими между 2 и 4 седмици. Точният срок ще бъде уточнен в офертата.
              </p>
            </div>
            
            <div className="mb-8">
              <h3 className="text-xl font-heading font-bold text-primary mb-2">
                Предоставяте ли гаранция за извършената работа?
              </h3>
              <p className="text-gray-700">
                Да, предоставяме гаранция за всички извършени от нас довършителни работи. Гаранционният срок варира според вида на работата и се уточнява в договора.
              </p>
            </div>
            
            <div>
              <h3 className="text-xl font-heading font-bold text-primary mb-2">
                Мога ли да доставя собствени материали?
              </h3>
              <p className="text-gray-700">
                Да, можете да доставите част или всички материали сами. Ние също можем да ви помогнем с избора и доставката на качествени материали на добри цени благодарение на нашите партньорства с доставчици.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
